<app-breadcrumb [links]="links" current="Gestao de Produtos"></app-breadcrumb>

<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base d-flex align-items-center position-relative top-119 pt-32">
    <div class="container">
      <div class="row  d-flex justify-content-center">
        <div class="col-12 col-md-6 col-lg-6 col-xl-6">
          <h1 class="text-white text-shadow">Gestão dos Produtos da Montra Online</h1>
        </div>
      </div>
      <div class="row py-2 align-items-center">
        <div class="col-12 col-md-7 col-lg-10 col-xl-8">
          <ul class="nav justify-content-between flex-sm-column flex-md-row flex-lg-row">
            <li class="nav-item py-sm-2">
              <a class="nav-link btn btn-grad pointer" (click)="filterType('alta')">Alta Relojoaria</a>
            </li>
            <li class="nav-item py-sm-2">
              <a class="nav-link btn btn-grad pointer" (click)="filterType('relogio')">Relojoaria</a>
            </li>
            <li class="nav-item py-sm-2">
              <a class="nav-link btn btn-grad pointer" (click)="filterType('j1')">Joalharia</a>
            </li>
            <li class="nav-item py-sm-2">
              <a class="nav-link btn btn-grad pointer" (click)="filterType('noiva')">Noivas</a>
            </li>
            <li class="nav-item py-sm-2">
              <a class="nav-link btn btn-grad pointer" (click)="filterType('j2')">Pratas</a>
            </li>
            <li class="nav-item py-sm-2">
              <a class="nav-link btn btn-grad pointer" (click)="filterType('acess')">Acessórios</a>
            </li>
            <li class="nav-item py-sm-2">
              <a class="nav-link btn btn-grad pointer" (click)="filterType('')">Todas</a>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-5 col-xl-4">
          <div class="d-flex flex-column mt-4">
            <input class="form-control me-2" type="search" placeholder="Termo a Pesquisar" aria-label="Search" [(ngModel)]="query" (keydown.enter)="search()">
            <div class="mt-2">
              <input class="input" id="customSwitch3" type="checkbox" [(ngModel)]="queryM">
              <label class="label" for="customSwitch3">
                <div class="left text-white">
                  Modelo / Referência
                </div>
                <div class="switch">
                  <span class="slider round"></span>
                </div>
                <div class="right text-white">
                  Marca
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-5 col-lg-4 col-xl-3">
          <ul class="nav justify-content-between flex-sm-column flex-md-row flex-lg-row">
            <li class="nav-item py-sm-2">
              <a class="nav-link active btn btn-grad pointer" (click)="exportExcel()">Exportar p/ Excel</a>
            </li>
            <li class="nav-item py-sm-2">
              <a class="nav-link btn btn-grad" (click)="exportPdf(true)">Exportar p/ PDF</a>
            </li>
            <li class="nav-item py-sm-2">
              <a class="nav-link btn btn-grad" (click)="exportPdf(false)">Imprimir</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="table-responsive py-5">
            <table class="table bg-light text-center table-hover table-striped">
              <thead class="">
                <tr class="">
                  <th scope="col">#</th>
                  <th scope="col">Categoria</th>
                  <th scope="col">Marca</th>
                  <th scope="col" class="px-16">Modelo</th>
                  <th scope="col">Referência</th>
                  <th colspan="2">Opções</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of produtos; let i = index">
                  <th scope="row" class="align-middle">{{i+1}}</th>
                  <td class=" align-middle">{{getTipo(item.tipo)}}</td>
                  <td class="align-middle">{{getMarca(item)}}</td>
                  <td class="align-middle">{{item.nome}}</td>
                  <td class="align-middle">{{item.ref}}</td>
                  <th scope="col" class="align-middle"><a href="admin/produtos?id={{item.id}}" class="text-success">Editar</a></th>
                  <th scope="col" class="align-middle"><a class="text-danger pointer" (click)="delete(item)">Apagar</a></th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>